import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import NftMarketplaceLayer from "../../components/NFT/NftMarketplaceLayer";

const NftMarketplacePage = () => {
     return (
          <>
               {/* MasterLayout */}
               <MasterLayout>
                    {/* Breadcrumb */}
                    <Breadcrumb title="NFT Marketplace" />

                    {/* NftMarketplaceLayer */}
                    <NftMarketplaceLayer />
               </MasterLayout>
          </>
     );
};

export default NftMarketplacePage;
